var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tip-x",style:({ 'padding-left': _vm.padding + 'px' })},[_c('img',{staticClass:"image img",attrs:{"src":_vm.icon == 1 ? _vm.imageUrl : _vm.imageUrl2}}),_c('div',{staticClass:"title",class:{ 'title-white': _vm.icon == 2 }},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }